<template>
    <dash
        icon="fa fa-users"
        titulo="EQUIPE DE APOIO"
        subTitulo="GESCON"
        @click.native="$router.push({ name: 'Gescon_Gerentes_Apoios' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
